var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isEmail
        ? [
            _c(
              "a",
              { attrs: { href: `mailto:${_vm.itemValue.replace(/\s/g, "")}` } },
              [_vm._v(_vm._s(_vm.itemValue))]
            ),
          ]
        : _vm.isPhone
        ? [
            _c(
              "a",
              { attrs: { href: `tel:${_vm.itemValue.replace(/\s/g, "")}` } },
              [_vm._v(_vm._s(_vm.itemValue))]
            ),
          ]
        : _vm.isUrl
        ? [
            _c(
              "a",
              {
                attrs: {
                  href: `${_vm.itemValue.replace(/\s/g, "")}`,
                  target: "_blank",
                },
              },
              [_vm._v(_vm._s(_vm.itemValue))]
            ),
          ]
        : [_vm._v("\n        " + _vm._s(_vm.itemValue) + "\n    ")],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }